module.exports = new __parcel__URL__("wrike-logomark.67006734.svg").toString();